import { render } from "./etImgsView.vue?vue&type=template&id=2880f77f"
import script from "./etImgsView.vue?vue&type=script&lang=js"
export * from "./etImgsView.vue?vue&type=script&lang=js"

import "./etImgsView.vue?vue&type=style&index=0&id=2880f77f&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__